import { AxiosInstance, AxiosResponse } from 'axios';
import { ApplicationType } from '../../../../shared/types/ApplicationType';
import { ViewData } from '../../../../shared/types/ViewData/IViewData';
import { StatusCodes } from 'http-status-codes';

export type SwitchProductResponse = { success: boolean };

export class SwitchProduct {
  private dash_api: AxiosInstance;

  private logger: any;

  constructor(dash_api: AxiosInstance, logger: Console) {
    this.dash_api = dash_api;
    this.logger = logger;
  }

  private success(): SwitchProductResponse {
    return { success: true };
  }

  private failed(): SwitchProductResponse {
    return { success: false };
  }

  public async switch(application: ApplicationType): Promise<SwitchProductResponse> {
    try {
      const response: AxiosResponse<ViewData> = await this.dash_api.post(`/v1/dashboard-user/set-view`, {
        view: {
          switch_to: application,
        },
      });

      if (response.status === StatusCodes.OK) {
        return this.success();
      } else {
        return this.failed();
      }
    } catch (e) {
      this.logger?.error(e);
      return this.failed();
    }
  }
}
